import * as React from "react";
import {Fragment, Component} from "react";
import KeySolver from "../../KeySolver";

import multi from "../../assets/Icons/multi.svg"
import patterned from "../../assets/Icons/patterned.svg"
import uni from "../../assets/Icons/uni.svg"
import block from "../../assets/Icons/block.svg"

export default class Filter extends Component {

	constructor(props) {
		super(props);
		this.state = {
			categories: [],
			categoriesPattern: [],
			categoriesColors: [],

			color: false,
			type: false,

			itemsCount: 1,
		}
		this.filterString = React.createRef();
		this.filterItems = this.filterItems.bind(this);

		this.typeFilter = this.typeFilter.bind(this);
		this.colorFilter = this.colorFilter.bind(this);
		this.applyFilter = this.applyFilter.bind(this);
	}

	filterItems() {
		const filterString = this.filterString.current.value;
		const normalizedFilterString = filterString.toLowerCase().split(' ');

		const multipleInArray = (arr, values) => {
			return values.every(value => {
				return arr.some(item => {
					return item.includes(value);
				});
			});
		}

		const filterElement = document.querySelector(`[data-filterel="${this.props.filterel}"]`);
		const domElements = filterElement.querySelectorAll('[data-tags]');

		domElements.forEach(domElement => {
			const tags = domElement.dataset.tags.trim().split(',');

			domElement.classList.add('d-none');
			if(normalizedFilterString[0] === '') {
				domElement.classList.remove('d-none');
			} else {
				if(multipleInArray(tags, normalizedFilterString)) {
					domElement.classList.remove('d-none');
				}
			}
		});
	}

	typeFilter(v) {
		// console.log('apply type filter');
		// console.log(v);
		this.setState({type: v}, () => {
			this.applyFilter();
		});
	}

	colorFilter(v) {
		// console.log('apply color filter');
		// console.log(v);
		this.setState({color: v}, () => {
			this.applyFilter();
		});
	}

	applyFilter() {
		const {type, color} = this.state;
		let count = 0;
		document.querySelectorAll(`.pattern_${this.props.inputType}`).forEach(pattern => {
			let show = false;
			if(color) {
				if(pattern.dataset[color] === '1') {
					if(type) {
						if(pattern.dataset[type] === '1') {
							show = true;
						}
					} else {
						show = true;
					}
				}
			}
			if(type) {
				if(pattern.dataset[type] === '1') {
					if(color) {
						if(pattern.dataset[color] === '1') {
							show = true;
						}
					} else {
						show = true;
					}
				}
			}
			if(type === false && color === false) {
				show = true;
			}
			pattern.style.display = show ? 'inline-flex' : 'none';
			count = show ? (count + 1) : count;
		});
		this.setState({itemsCount: count});
	}

	componentDidMount() {
		const {items} = this.props;
		if(items.length > 0) {
			if(items[0].categories) {
				this.setState({categories: items[0].categories}, () => {
					this.setState({
						categoriesPattern: {
							uni: items[0].categories.uni,
							multi: items[0].categories.multi,
							block: items[0].categories.block,
							patterned: items[0].categories.patterned
						}
					}, () => {
						const {categories} = this.state;
						let colors = [];
						for (let i in categories) {
							if(i !== 'uni' && i !== 'multi' && i !== 'block' && i !== 'patterned') {
								colors[i] = categories[i];
							}
						}
						this.setState({categoriesColors: colors});
					});
				});
			}
		}
	}

	render() {

		const {placeholder} = this.props;
		const {categories, categoriesPattern, categoriesColors, itemsCount} = this.state;

		return (
			<Fragment>
				<div className="row align-items-center">
					{Object.keys(categories).length > 0 &&
						<div className="col-md-10">
							<div className="category-wrapper">
								<Categories categories={categoriesPattern} renderSpan={true} filter={(p) => this.typeFilter(p)} />
							</div>
							<Categories categories={categoriesColors} filter={(p) => this.colorFilter(p)} />
						</div>
					}
					<div className={Object.keys(categories).length > 0 ? `col-md-2 text-end` : `col-md-2 ms-auto text-end`} >
						<div className="filter">
							<input ref={this.filterString} type="text" className="form-control form-control-sm" placeholder={placeholder} onChange={() => this.filterItems()} />
						</div>
					</div>
				</div>
				{itemsCount === 0 &&
					<div className="d-block my-5 text-center">
						<span>Es konnten keine Elemente gefunden werden.</span>
					</div>
				}
			</Fragment>
		);
	}
}

class Categories extends Component {

	constructor(props) {
		super(props);
		this.state = {
			selectedFilter: false
		}
		this.handleSelect = this.handleSelect.bind(this);
	}

	handleSelect(key) {
		this.setState({selectedFilter: key}, () => {
			const {filter} = this.props;
			filter(key);
		});
	}

	render() {

		const {categories, renderSpan} = this.props;
		const {selectedFilter} = this.state;

		return (
			<Fragment>
				{Object.keys(categories).map((category, i) =>
					<Fragment key={KeySolver()} >
						<div className="filter-el">
							<button type="button" className={`filter-btn ${Object.keys(categories)[i]}`} title={Object.values(categories)[i].label} style={{backgroundColor: (Object.values(categories)[i].color ? Object.values(categories)[i].color : 'none')}} onClick={() => this.handleSelect((selectedFilter === category ? false : category))}>
								{selectedFilter === category &&
									<i className="fas fa-check" />
								}
								{Object.keys(categories)[i] === 'patterned' &&
									<img src={patterned} className="preview" alt={Object.keys(categories)[i]} />
								}
								{Object.keys(categories)[i] === 'block' &&
									<img src={block} className="preview" alt={Object.keys(categories)[i]} />
								}
								{Object.keys(categories)[i] === 'uni' &&
									<img src={uni} className="preview" alt={Object.keys(categories)[i]} />
								}
								{Object.keys(categories)[i] === 'multi' &&
									<img src={multi} className="preview" alt={Object.keys(categories)[i]} />
								}
							</button>
							{selectedFilter && renderSpan &&
								<Fragment>
									{selectedFilter === category &&
										<Fragment>
											<span>
												{Object.values(categories)[i].label}
											</span>
										</Fragment>
									}
								</Fragment>
							}
						</div>
					</Fragment>
				)}
			</Fragment>
		);
	}
}
